import { useEffect, useState } from 'react';
import {
  ANDROID_STORE_URL,
  IOS_STORE_URL,
} from '../constants/deeplink/constants';

const DeeplinkScreen = () => {
  const [link, setLink] = useState('');
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setLink(IOS_STORE_URL);
      window.location.replace(IOS_STORE_URL);
    } else if (/android/i.test(userAgent)) {
      setLink(ANDROID_STORE_URL);
      window.location.replace(ANDROID_STORE_URL);
    } else {
      setShowFallback(true);
    }
  }, []);

  if (showFallback) {
    return (
      <div className="max-w-[400px] mx-auto text-center p-5 font-sans flex flex-col items-center justify-center min-h-screen">
        <h1 className="text-2xl mb-2">Pikko Pay</h1>
        <p className="text-gray-500 mb-5">Téléchargez l'app sur votre store</p>
        <div>
          <a
            className="inline-block py-3 px-6 bg-[#007aff] text-white rounded-lg no-underline font-semibold mr-2"
            href={IOS_STORE_URL}
          >
            App Store
          </a>
          <a
            className="inline-block py-3 px-6 bg-[#007aff] text-white rounded-lg no-underline font-semibold"
            href={ANDROID_STORE_URL}
          >
            Google Play
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[400px] mx-auto text-center p-5 font-sans flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl mb-2">Pikko Pay</h1>
      <p className="text-gray-500 mb-5">Redirection vers le store...</p>
      {link && (
        <a
          className="inline-block py-3 px-6 bg-[#007aff] text-white rounded-lg no-underline font-semibold"
          href={link}
        >
          Télécharger l'app
        </a>
      )}
    </div>
  );
};

export default DeeplinkScreen;
